import ComponentLoader from 'components/ComponentLoader'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import React from 'react'
import getSectionComponentRouteUtil from 'modules/routes/utils/routes/get-section'

const SECTION_ITEM_TO_ASYNC_IMPORT_FUNC_COMPONENT = {
  [SECTIONS_NAME.ARTICLES]: () => {
    if (!ARTICLE && !(SERVER && global.ARTICLE)) {
      return import(/* webpackChunkName: "pages/Article" */ 'pages/Article')
    }
  },
  [SECTIONS_NAME.STORE]: () => {
    if (!PRODUCT && !(SERVER && global.PRODUCT)) {
      return import(/* webpackChunkName: "containers/Product" */ 'pages/Product')
    }
  },
  [SECTIONS_NAME.MOTIVATION]: () => {
    if (!MOTIVATION && !(SERVER && global.MOTIVATION)) {
      return import(/* webpackChunkName: "pages/Motivation" */ 'pages/Motivation')
    }
  }
}

const SECTION_ITEM_TO_FUNC_COMPONENT = {
  [SECTIONS_NAME.ARTICLES]: () => {
    if ((ARTICLE || (SERVER && global.ARTICLE))) {
      return require('pages/Article').default
    }
  },
  [SECTIONS_NAME.STORE]: () => {
    if ((PRODUCT || (SERVER && global.PRODUCT))) {
      return require('pages/Product').default
    }
  },
  [SECTIONS_NAME.MOTIVATION]: () => {
    if ((MOTIVATION || (SERVER && global.MOTIVATION))) {
      return require('pages/Motivation').default
    }
  }
}

export default function getCategoryOrItemComponentUtil (props) {
  const { pathname } = props.match
  const categoryOrSlug = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (!categoryOrSlug.includes('-')) {
    return getSectionComponentRouteUtil(props)
  }

  const { section } = props.route
  const importFunc = SECTION_ITEM_TO_ASYNC_IMPORT_FUNC_COMPONENT[section]
  const importItemComponent = importFunc && importFunc()
  if (importItemComponent) {
    return (
      <ComponentLoader
        loadComponent={importItemComponent}
        {...props}
      />
    )
  }

  const componentFunc = SECTION_ITEM_TO_FUNC_COMPONENT[section]
  const Component = componentFunc && componentFunc()
  if (!Component) {
    return <div />
  }

  return (
    <Component
      {...props}
    />
  )
}
